import { render, staticRenderFns } from "./SettingsTokens.vue?vue&type=template&id=ffa2884c"
import script from "./SettingsTokens.vue?vue&type=script&lang=js"
export * from "./SettingsTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports